import { __awaiter } from "tslib";
import ReadStep from "./tts/ReadStep";
/**
 * Waits for the text to speech api to finish its utterance
 * @param ctx - The object that contains all of the components needed by an action to execute (ex. cpu, ram, etc.)
 * @returns
 */
export function TTS_FINISHED(ctx) {
    return __awaiter(this, void 0, void 0, function* () {
        return ReadStep.utteranceEndedPromise;
    });
}
